import { ValidatorFn, Validators } from '@angular/forms';

//Phone validator for mobile phone number that is entered through inputs
//Validates only Swedish mobile phone numbers (third digit is 7, fourth digit is 0,2,3,6 or 9)
//eg. +46 725 678 567
export const swedishMobilePhoneValidator: ValidatorFn[] = [
	Validators.required,
	Validators.pattern(/^([+]46)\s*(7[02369])\s*(\d{4})\s*(\d{3})$/),
];
